/* eslint-disable no-unused-vars */
import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css' //for toastify

//services: REQUIRED even unused
import { firebaseConfig } from './services/firebase/config'
import { initializeApp } from 'firebase/app'
//

import { AuthProvider } from './pages/Auth'
import AppRoutes from './App.routes'
import { initiateSites } from './model/Sites'

const App = () => {
  // const [token, setToken] = useState(null);
  const theme = createTheme()
  //check for token upon render
  // useEffect(() => {
  //   const stored = sessionStorage.getItem("token"); //token is key here
  //   if (stored !== null) {
  //     setToken(JSON.parse(stored)); //token change would allow them to visit other page
  //   } else {
  //     return; //do nothing
  //   }
  // }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <AppRoutes />
          <ToastContainer />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App
